var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudmid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1415,
    height: 471,
    viewBox: "0 0 1415 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_376_504",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1415,
    height: 471
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M497.723 130.106C457.992 106.671 430.722 142.655 430.722 184.481C336.601 65.274 223.337 167.751 247.266 309.964C215.361 309.964 196.218 328.787 199.408 387.346C174.595 396.384 158.778 403.146 151.55 429.172C78.719 429.712 39.3294 431.684 0 471L1415 462.634C1392.67 420.807 1357.57 424.991 1245.9 420.807C1231.54 396.831 1220.11 389.256 1191.66 389.436C1179.65 358.4 1167.33 359.426 1143.8 366.431C1118.28 324.605 1092.76 312.056 1044.9 358.066C1038.52 337.153 1027.35 324.605 1005.02 341.335C981.088 232.584 914.087 199.122 819.966 266.045C819.966 201.213 772.108 153.112 722.655 192.847C722.177 164.538 717.956 153.67 692.345 157.294C729.036 -28.8377 500.913 -64.3912 497.723 130.106Z",
    fill: "#FAFAFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_376_504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.723 130.106C457.992 106.671 430.722 142.655 430.722 184.481C336.601 65.274 223.337 167.751 247.266 309.964C215.361 309.964 196.218 328.787 199.408 387.346C174.595 396.384 158.778 403.146 151.55 429.172C78.719 429.712 39.3294 431.684 0 471L1415 462.634C1392.67 420.807 1357.57 424.991 1245.9 420.807C1231.54 396.831 1220.11 389.256 1191.66 389.436C1179.65 358.4 1167.33 359.426 1143.8 366.431C1118.28 324.605 1092.76 312.056 1044.9 358.066C1038.52 337.153 1027.35 324.605 1005.02 341.335C981.088 232.584 914.087 199.122 819.966 266.045C819.966 201.213 772.108 153.112 722.655 192.847C722.177 164.538 717.956 153.67 692.345 157.294C729.036 -28.8377 500.913 -64.3912 497.723 130.106Z",
    fill: "#FAFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M498.224 284.103C461.777 268.265 436.761 292.584 436.761 320.852C350.421 240.287 246.52 309.545 268.471 405.657C239.203 405.657 221.642 418.379 224.569 457.955C201.806 464.063 187.297 468.633 180.667 486.223C113.856 486.587 77.7224 487.92 41.644 514.491L1339.68 508.837C1319.19 480.569 1286.99 483.396 1184.56 480.569C1171.38 464.365 1160.9 459.246 1134.8 459.368C1123.78 438.392 1112.48 439.086 1090.9 443.82C1067.49 415.552 1044.07 407.071 1000.17 438.166C994.315 424.033 984.072 415.552 963.584 426.859C941.633 353.361 880.17 330.746 793.83 375.975C793.83 332.16 749.928 299.651 704.563 326.506C704.124 307.373 700.252 300.028 676.758 302.477C710.416 176.683 501.151 152.655 498.224 284.103Z",
    fill: "#A5DFFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudmid);
export default __webpack_public_path__ + "static/media/cloudmid.9059a45ee1e9789e8f5072215f52ae17.svg";
export { ForwardRef as ReactComponent };